import * as effects from 'redux-saga/effects';
import { IApplicationState } from '../';
import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import { isNull, isNullOrUndefinedOrEmptyString } from '../../Utils/Various';
import {
	addUserResourceRights,
	createACLUsers,
	createACLUsersFailed,
	createACLUsersSucceed,
	createMultipleACLUsers,
	deleteUserResource,
	emptyList,
	emptyListRights,
	emptyListUsernames,
	getACLParents,
	getACLParentsFailed,
	getACLParentsSucceed,
	getACLRights,
	getACLRightsFailed,
	getACLRightsSucceed,
	getACLUserByID,
	getACLUserByIDFailed,
	getACLUserByIDSucceed,
	getACLUsers,
	getACLUsersFailed,
	getACLUsersSucceed,
	getAllACLUsernames,
	getAllACLUsernamesFailed,
	getAllACLUsernamesSucceed,
	getUserRights,
	getUserRigthsSucceed,
	impersonate,
	impersonateFailed,
	impersonateSucceed,
	isLoading,
	isUserAlreadyPresent,
	isUserAlreadyPresentSucceed,
	modifyACLUserDateDebut,
	modifyACLUserDateExpire,
	modifyACLUserEmail,
	modifyACLUserFirstname,
	modifyACLUserIsActive,
	modifyACLUserIsActiveSucceed,
	modifyACLUserIsActiveFailed,
	modifyACLUserLanguage,
	modifyACLUserLocalisation,
	modifyACLUserName,
	modifyACLUserParent,
	modifyACLUserPhone,
	modifyACLUserPosition,
	modifyACLUserUsername,
	setLastParams,
	updateUserResourceRights,
	updateRightsBatch,
	setRightsLoading
} from './Actions';
import {
	IUserCreationParams,
	IUserManagementActionTypes,
	IUserSearchParams,
	IUserSearchParamsSorting,
	UserACL,
} from './Types';
import { getACLResources } from '../ResourcesManagement/Actions';
import { setError, setSuccessMessage } from '../NotificationBar/Actions';
import { types } from 'util';

export const getParams = (state: IApplicationState) =>
	state.userManagement.lastSearchParams;

export const getParamsSorting = (state: IApplicationState) =>
	state.userManagement.lastSearchParamsSorting;

function* handleCreateACLUser(action: ReturnType<typeof createACLUsers>) {
	const backend = Backend.getInstance();
	let params = action.payload[1] as IUserCreationParams;
	if (isNull(params)) {
		params = yield effects.select(
			getParams
		) as unknown as IUserCreationParams | null;
	}
	if (isNull(params)) {
		yield effects.put(createACLUsersFailed('No creation parameters'));
		Logger.warn({}, 'Failed creating users');
		return;
	}

	try {
		let dateCreationFormated = params.dateCreation.replace('T', ' ');
		let dateDebutFormated = params.dateDebut.replace('T', ' ');

		// Date format : 09/06/2021 16:34:00
		// Expected format : 2021-06-09 00:00:00 <-- to avoid dealing with UTC

		const dateCreation = dateCreationFormated.split(' ');
		const dateDebut = dateDebutFormated.split(' ');

		const dateCreation2 = dateCreation[0].split('/');
		const dateDebut2 = dateDebut[0].split('/');

		dateCreationFormated =
			dateCreation2[2] +
			'-' +
			dateCreation2[1] +
			'-' +
			dateCreation2[0] +
			' ' +
			'00:00:00';
		dateDebutFormated =
			dateDebut2[2] +
			'-' +
			dateDebut2[1] +
			'-' +
			dateDebut2[0] +
			' ' +
			'00:00:00';
		yield effects.apply(backend, backend.createACLUser, [
			action.payload[0],
			dateCreationFormated,
			dateDebutFormated,
			params.email,
			params.firstname,
			params.isActive,
			params.isGroup,
			params.name,
			params.parentID,
			params.password,
			params.username,
			params.phone,
			params.position,
			params.localisation,
			params.language,
		] as any);
		yield effects.put(createACLUsersSucceed());
	} catch (err) {
		yield effects.put(createACLUsersFailed(String(err)));
		Logger.warn({ err }, 'Failed creating users');
	}
}

function* handleCreateMultipleACLUser(action: ReturnType<typeof createMultipleACLUsers>) {
	const backend = Backend.getInstance();

	try {
		yield effects.put(isLoading(true));
		let createdUsers = action.payload[1] as any;

		createdUsers.forEach(
			(u: {
				dateCreation: string;
				dateCreationFormated: string;
				dateDebut: string;
				dateDebutFormated: string;
				email: string;
				firstname: string;
				isActive: boolean;
				isGroup: boolean;
				language: string;
				lastname: string;
				localisation: string[];
				parentID: number;
				parentName: string;
				password: string;
				phone: string;
				position: string;
				username: string;
			}) => {
				let dateCreationFormated = u.dateCreation.replace('T', ' ');
				let dateDebutFormated = u.dateDebut.replace('T', ' ');

				// Date format : 09/06/2021 16:34:00
				// Expected format : 2021-06-09 00:00:00 <-- to avoid dealing with UTC

				const dateCreation = dateCreationFormated.split(' ');
				const dateDebut = dateDebutFormated.split(' ');

				const dateCreation2 = dateCreation[0].split('/');
				const dateDebut2 = dateDebut[0].split('/');

				dateCreationFormated =
					dateCreation2[2] +
					'-' +
					dateCreation2[1] +
					'-' +
					dateCreation2[0] +
					' ' +
					'00:00:00';
				dateDebutFormated =
					dateDebut2[2] +
					'-' +
					dateDebut2[1] +
					'-' +
					dateDebut2[0] +
					' ' +
					'00:00:00';

				u.dateCreationFormated = dateCreationFormated;
				u.dateDebutFormated = dateDebutFormated;
			}
		);

		yield effects.apply(backend, backend.createMultipleACLUser, [
			action.payload[0],
			createdUsers,
		] as any);

		yield effects.put(createACLUsersSucceed());
		yield effects.put(setSuccessMessage('Users created successfully'));
		yield effects.put(emptyList());
	} catch (err) {
		yield effects.put(createACLUsersFailed(String(err)));
		yield effects.put(setError(new Error(String(err))));
		Logger.warn({ err }, 'Failed creating users');
	} finally {
		yield effects.put(isLoading(false));
	}
}

function* handleDeleteUserResource(
	action: ReturnType<typeof deleteUserResource>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.deleteUserResource, [
			action.payload[0],
			action.payload[1],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user rights');
	}
}

function* handleGetACLParentsResearch(
	action: ReturnType<typeof getACLParents>
) {
	const backend = Backend.getInstance();

	//yield effects.put(emptyList());
	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getACLUsersResearch, [
			action.payload[0],
			10,
			0,
			'ID',
			'asc',
			action.payload[1],
			true,
			true,
			0,
		] as any);
		yield effects.put(getACLParentsSucceed(res));
	} catch (err) {
		yield effects.put(
			getACLParentsFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting parent users');
	}
}

function* handleGetAllACLUsername(
	action: ReturnType<typeof getAllACLUsernames>
) {
	const backend = Backend.getInstance();

	yield effects.put(emptyListUsernames());
	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getAllACLUsername, [
			action.payload[0],
		] as any);
		let users: UserACL[] = res.users;
		let email: string[] = [];
		let usernames: string[] = [];

		users.forEach((user) => {
			if (!isNullOrUndefinedOrEmptyString(user.username)) {
				usernames.push(user.username.toLowerCase());
				if (!isNullOrUndefinedOrEmptyString(user.email)) {
					email.push(user.email.toLowerCase());
				}
			}
		});

		yield effects.put(getAllACLUsernamesSucceed(email, usernames));
	} catch (err) {
		yield effects.put(
			getAllACLUsernamesFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting resources');
	}
}
function* handleGetACLRights(action: ReturnType<typeof getACLRights>) {
	const backend = Backend.getInstance();

	yield effects.put(emptyListRights());
	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getACLRights, [
			action.payload[0],
		] as any);
		yield effects.put(getACLRightsSucceed(res));
	} catch (err) {
		yield effects.put(
			getACLRightsFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting rights');
	}
}

function* handleGetACLUserByID(action: ReturnType<typeof getACLUserByID>) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getACLUserByID, [
			action.payload[0],
			action.payload[1],
		] as any);
		yield effects.put(getACLUserByIDSucceed(res));
	} catch (err) {
		yield effects.put(
			getACLUserByIDFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting user');
	}
}

function* handleGetACLUsersResearch(action: ReturnType<typeof getACLUsers>) {
	const backend = Backend.getInstance();
	let params = action.payload[1] as IUserSearchParams;
	if (isNull(params)) {
		params = yield effects.select(
			getParams
		) as unknown as IUserSearchParams | null;
	}
	if (isNull(params)) {
		yield effects.put(getACLUsersFailed('No search parameters'));
		Logger.warn({}, 'Failed getting users');
		return;
	}

	let paramsSorting = action.payload[2] as IUserSearchParamsSorting;
	if (isNull(paramsSorting)) {
		paramsSorting = yield effects.select(
			getParamsSorting
		) as unknown as IUserSearchParamsSorting | null;
	}
	if (isNull(paramsSorting)) {
		yield effects.put(getACLUsersFailed('No search parameters'));
		Logger.warn({}, 'Failed getting users');
		return;
	}

	yield effects.put(emptyList());
	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getACLUsersResearch, [
			action.payload[0],
			action.payload[3],
			action.payload[4],
			paramsSorting.sortingBy,
			paramsSorting.sortingOrder,
			params.researchText,
			params.showInactive,
			params.isGroup,
			params.usersParentID,
		] as any);
		yield effects.put(getACLUsersSucceed(res));
		yield effects.put(setLastParams(params));
	} catch (err) {
		yield effects.put(
			getACLUsersFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting users');
	}
}

function* handleGetUserRights(action: ReturnType<typeof getUserRights>) {
	const backend = Backend.getInstance();
	yield effects.put(emptyList());
	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getUserRights, [
			action.payload[0],
			action.payload[1],
		] as any);
		yield effects.put(getUserRigthsSucceed(res));
	} catch (err) {
		yield effects.put(
			getACLParentsFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting users');
	}
}

function* handleIsUserPresent(action: ReturnType<typeof isUserAlreadyPresent>) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.isUserPresent, [
			action.payload[0],
			action.payload[1],
		] as any);

		yield effects.put(isUserAlreadyPresentSucceed(res.message));
	} catch (err) {
		Logger.warn({ err }, 'Failed, please contact support');
	}
}

function* handleModifyACLUserDateDebut(
	action: ReturnType<typeof modifyACLUserDateDebut>
) {
	const backend = Backend.getInstance();

	let date1 = action.payload[2] as string;

	const date = date1.split(' ');

	const date2 = date[0].split('/');

	const dateFormated =
		date2[2] + '-' + date2[1] + '-' + date2[0] + ' 00:00:00';

	try {
		yield effects.apply(backend, backend.modifyACLUserDateDebut, [
			action.payload[0],
			action.payload[1],
			dateFormated,
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleModifyACLUserDateExpire(
	action: ReturnType<typeof modifyACLUserDateExpire>
) {
	const backend = Backend.getInstance();

	let date1 = action.payload[2] as string;

	const date = date1.split(' ');

	const date2 = date[0].split('/');

	const dateFormated =
		date2[2] + '-' + date2[1] + '-' + date2[0] + ' 00:00:00';

	try {
		yield effects.apply(backend, backend.modifyACLUserDateExpire, [
			action.payload[0],
			action.payload[1],
			dateFormated,
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleModifyACLUserEmail(
	action: ReturnType<typeof modifyACLUserEmail>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserEmail, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleModifyACLUserFirstname(
	action: ReturnType<typeof modifyACLUserFirstname>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserFirstname, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleModifyACLUserIsActive(action: ReturnType<typeof modifyACLUserIsActive>) {
	const backend = Backend.getInstance();
	try {
		yield effects.apply(backend, backend.modifyACLUserIsActive, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		]);
		
		// Passer l'ID de l'utilisateur et son nouvel état
		yield effects.put(modifyACLUserIsActiveSucceed(action.payload[1], action.payload[2]));
		yield effects.put(setSuccessMessage('User successfully deleted'));
	} catch (e) {
		yield effects.put(modifyACLUserIsActiveFailed(e.message));
		yield effects.put(setError(e.message));
	}
}

function* handleModifyACLUserLanguage(
	action: ReturnType<typeof modifyACLUserLanguage>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserLanguage, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleModifyACLUserLocalisation(
	action: ReturnType<typeof modifyACLUserLocalisation>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserLocalisation, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}
function* handleModifyACLUserName(
	action: ReturnType<typeof modifyACLUserName>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserName, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleModifyACLUserParent(
	action: ReturnType<typeof modifyACLUserParent>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserParent, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleModifyACLUserPhone(
	action: ReturnType<typeof modifyACLUserPhone>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserPhone, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleModifyACLUserPosition(
	action: ReturnType<typeof modifyACLUserPosition>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserPosition, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}
function* handleModifyACLUserUsername(
	action: ReturnType<typeof modifyACLUserUsername>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.modifyACLUserUsername, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user');
	}
}

function* handleAddUserResourceRights(
	action: ReturnType<typeof addUserResourceRights>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.addUserResourceRights, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
			action.payload[3],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user rights');
	}
}

function* handleUpdateUserResourceRights(
	action: ReturnType<typeof updateUserResourceRights>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(backend, backend.updateUserResourceRights, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
		] as any);
	} catch (err) {
		Logger.warn({ err }, 'Failed updating user rights');
	}
}

function* handleImpersonate(action: ReturnType<typeof impersonate>) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.impersonate, [
			action.payload[0],
			action.payload[1],
		] as any);
		if (!isNullOrUndefinedOrEmptyString(res.token)) {
			yield effects.put(impersonateSucceed(res.token));
		} else {
			if (!isNullOrUndefinedOrEmptyString(res.message)) {
				yield effects.put(impersonateFailed(res.message));
			} else {
				yield effects.put(impersonateFailed('unexpected error'));
			}
		}
	} catch (err) {
		Logger.warn({ err }, 'Failed impersonate');
	}
}

function* handleUpdateRightsBatch(action: ReturnType<typeof updateRightsBatch>) {
	const { token, userId, addedRights, resourceIDsRightsToBeDeleted, resourceIDsRightsToBeUpdated } = action.payload;
	const backend = Backend.getInstance();

	try {
		yield effects.put(setRightsLoading(true));

		// Delete resources
		for (const resourceId of resourceIDsRightsToBeDeleted) {
			yield effects.apply(backend, backend.deleteUserResource, [token, resourceId]);
		}

		// Add new rights
		for (const right of addedRights) {
			yield effects.apply(backend, backend.addUserResourceRights, [token, userId, right.resourceId, right.rightsId]);
		}

		// Update existing rights
		for (const right of resourceIDsRightsToBeUpdated) {
			yield effects.apply(backend, backend.updateUserResourceRights, [token, right.usersResourcesID, right.rightsId]);
		}

		yield effects.put(getUserRights(token, userId));
		yield effects.put(getACLResources(token));
		yield effects.put(setSuccessMessage('Rights updated successfully'));
	} catch (error) {
		if (types.isNativeError(error)) {
			yield effects.put(setError(error));
		} else if (typeof error === "string"){
			yield effects.put(setError(new Error(error)));
		} else {
			Logger.console.warn(error);
			yield effects.put(setError(new Error("unknown error occurred")));
		}
	} finally {
		yield effects.put(setRightsLoading(false));
	}
}

function* watchAddUserResourceRights() {
	yield effects.takeEvery(
		IUserManagementActionTypes.ADD_USER_RESOURCE_RIGHTS,
		handleAddUserResourceRights
	);
}

function* watchCreateACLUser() {
	yield effects.takeLatest(
		IUserManagementActionTypes.CREATE_ACL_USERS,
		handleCreateACLUser
	);
}

function* watchCreateMultipleACLUser() {
	yield effects.takeLatest(
		IUserManagementActionTypes.CREATE_MULTIPLE_ACL_USERS,
		handleCreateMultipleACLUser
	);
}

function* watchDeleteUserResource() {
	yield effects.takeLatest(
		IUserManagementActionTypes.DELETE_USER_RESOURCE,
		handleDeleteUserResource
	);
}

function* watchGetACLParentsResearch() {
	yield effects.takeLatest(
		IUserManagementActionTypes.GET_ACL_PARENTS,
		handleGetACLParentsResearch
	);
}

function* watchGetAllACLUsernames() {
	yield effects.takeLatest(
		IUserManagementActionTypes.GET_ALL_ACL_USERNAMES,
		handleGetAllACLUsername
	);
}

function* watchGetACLRights() {
	yield effects.takeLatest(
		IUserManagementActionTypes.GET_ACL_RIGHTS,
		handleGetACLRights
	);
}

function* watchGetACLUserByID() {
	yield effects.takeLatest(
		IUserManagementActionTypes.GET_ACL_USER_BY_ID,
		handleGetACLUserByID
	);
}

function* watchGetACLUsersResearch() {
	yield effects.takeLatest(
		IUserManagementActionTypes.GET_ACL_USERS,
		handleGetACLUsersResearch
	);
}

function* watchGetUserRights() {
	yield effects.takeLatest(
		IUserManagementActionTypes.GET_USER_RIGHTS,
		handleGetUserRights
	);
}

function* watchIsUserPresent() {
	yield effects.takeLatest(
		IUserManagementActionTypes.IS_USER_ALREADY_PRESENT,
		handleIsUserPresent
	);
}

function* watchModifyACLUserDateDebut() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_DATE_DEBUT,
		handleModifyACLUserDateDebut
	);
}

function* watchModifyACLUserDateExpire() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_DATE_EXPIRE,
		handleModifyACLUserDateExpire
	);
}

function* watchModifyACLUserEmail() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_EMAIL,
		handleModifyACLUserEmail
	);
}

function* watchModifyACLUserFirstname() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_FIRSTNAME,
		handleModifyACLUserFirstname
	);
}

function* watchModifyACLUserIsActive() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_IS_ACTIVE,
		handleModifyACLUserIsActive
	);
}

function* watchModifyACLUserLanguage() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_LANGUAGE,
		handleModifyACLUserLanguage
	);
}

function* watchModifyACLUserLocalisation() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_LOCALISATION,
		handleModifyACLUserLocalisation
	);
}

function* watchModifyACLUserName() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_NAME,
		handleModifyACLUserName
	);
}

function* watchModifyACLUserParent() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_PARENT,
		handleModifyACLUserParent
	);
}

function* watchModifyACLUserPhone() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_PHONE,
		handleModifyACLUserPhone
	);
}

function* watchModifyACLUserPosition() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_POSITION,
		handleModifyACLUserPosition
	);
}

function* watchModifyACLUserUsername() {
	yield effects.takeLatest(
		IUserManagementActionTypes.MODIFY_ACL_USER_USERNAME,
		handleModifyACLUserUsername
	);
}

function* watchUpdateUserResourceRights() {
	yield effects.takeEvery(
		IUserManagementActionTypes.UPDATE_USER_RESOURCE_RIGHTS,
		handleUpdateUserResourceRights
	);
}

function* watchImpersonate() {
	yield effects.takeLatest(
		IUserManagementActionTypes.IMPERSONATE,
		handleImpersonate
	);
}

function* watchUpdateRightsBatch() {
	yield effects.takeLatest(
		IUserManagementActionTypes.UPDATE_RIGHTS_BATCH,
		handleUpdateRightsBatch
	);
}

export function* UserManagementSaga(): Generator<
	effects.AllEffect<effects.ForkEffect<void>>,
	void
> {
	yield effects.all([effects.fork(watchAddUserResourceRights)]);
	yield effects.all([effects.fork(watchCreateACLUser)]);
	yield effects.all([effects.fork(watchCreateMultipleACLUser)]);
	yield effects.all([effects.fork(watchDeleteUserResource)]);
	yield effects.all([effects.fork(watchGetACLParentsResearch)]);
	yield effects.all([effects.fork(watchGetACLRights)]);
	yield effects.all([effects.fork(watchGetACLUserByID)]);
	yield effects.all([effects.fork(watchGetACLUsersResearch)]);
	yield effects.all([effects.fork(watchGetAllACLUsernames)]);
	yield effects.all([effects.fork(watchGetUserRights)]);
	yield effects.all([effects.fork(watchImpersonate)]);
	yield effects.all([effects.fork(watchIsUserPresent)]);
	yield effects.all([effects.fork(watchModifyACLUserDateDebut)]);
	yield effects.all([effects.fork(watchModifyACLUserDateExpire)]);
	yield effects.all([effects.fork(watchModifyACLUserEmail)]);
	yield effects.all([effects.fork(watchModifyACLUserFirstname)]);
	yield effects.all([effects.fork(watchModifyACLUserIsActive)]);
	yield effects.all([effects.fork(watchModifyACLUserLanguage)]);
	yield effects.all([effects.fork(watchModifyACLUserLocalisation)]);
	yield effects.all([effects.fork(watchModifyACLUserName)]);
	yield effects.all([effects.fork(watchModifyACLUserParent)]);
	yield effects.all([effects.fork(watchModifyACLUserPhone)]);
	yield effects.all([effects.fork(watchModifyACLUserPosition)]);
	yield effects.all([effects.fork(watchModifyACLUserUsername)]);
	yield effects.all([effects.fork(watchUpdateUserResourceRights)]);
	yield effects.all([effects.fork(watchUpdateRightsBatch)]);
}
